export const inputCheck = (data, key, eventValue,regex = /[^\d.-]/g) => {
    const sanitizedValue = eventValue.replace(regex, '');
    return data[key] = sanitizedValue
}
export const generateRandomString = ()=> {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'; // 所有可能的字符
    let randomString = '';

    for (let i = 0; i < 16; i++) {  // 生成 16 位字符串
        const randomIndex = Math.floor(Math.random() * chars.length);  // 随机选取字符
        randomString += chars[randomIndex];
    }

    return randomString;
}
export const isValid = (value)=>{
    return value || value === '0' || value === 0
}

export const toFixed = (value, decimals = 3)=> {
    // 验证参数
    if (isNaN(value)) {
        return "";
    }
    if (decimals < 0 || !Number.isInteger(decimals)) {
        console.warn("小数位长度必须是非负整数");
        return value.toString();
    }

    // 使用 Number.toFixed 方法保留小数
    const num = Number(value);
    return num.toFixed(decimals);
}
